<template>
<div>
  <el-card body-style="padding: 0">
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">任务订单</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="10">
        <!-- <el-col :span="6">
          <el-form-item label="任务店铺" prop="shopInfo">
            <el-select v-model="queryForm.shopInfo" clearable placeholder="请选择任务类型">
              <el-option
                  v-for="item in allShops"
                  :key="item.id"
                  :label="item.shopName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="6">
          <el-form-item label="任务类型" prop="tasktype">
            <el-select v-model="queryForm.tasktype" clearable placeholder="请选择任务类型">
              <el-option
                  v-for="item in allTaskTypes"
                  :key="item.id"
                  :label="item.taskName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="任务编号" prop="taskId">
            <el-input v-model="queryForm.taskId" placeholder="请输入任务编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="网店订单号" prop="plateordernum">
            <el-input v-model="queryForm.plateordernum" placeholder="请输入编号"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="订单编号" prop="orderNum">
            <el-input v-model="queryForm.orderNum" placeholder="请输入系统订单编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="买手编号" prop="customerId">
            <el-input v-model="queryForm.customerId" placeholder="请输入编号"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="接单账号" prop="plateformUsername">
            <el-input v-model="queryForm.plateformUsername" placeholder="请输入账号"/>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="6">
          <el-form-item label="追评状态" prop="reviewstatus">
            <el-select v-model="queryForm.reviewstatus" clearable placeholder="请选择">
              <el-option
                  v-for="item in options"
                  :key="item.reviewStatus"
                  :label="item.reviewStatus"
                  :value="item.reviewStatus"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        </el-row>
        <el-row :gutter="10">
          <el-col :span="9">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!--<el-col :span="6">
            <el-form-item label="好评类型" prop="reviewtype">
              <el-select v-model="queryForm.reviewtype" clearable placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="8" :offset="1">
           <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportUserOrderInfo()" icon="el-icon-refresh">
              导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
  <el-card body-style="padding: 1%">
    <el-tabs class="el-tabs-self" v-model="tabsActive" @tab-click="tableChange">
      <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.lable" :name="item.value">
      </el-tab-pane>
    </el-tabs>
    <task-order-component ref="taskOrderCom"
                          :currentMenu="tabsActives[tabsActive]"
                          :queryForm="queryForm"
                          :pagination="pagination"
                          @changePageination="changePageInfo">
    </task-order-component>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px; margin-top: 20px">
    </el-pagination>
  </el-card>
  <customer-service-component></customer-service-component>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import TaskOrderComponent from './TaskOrderComponent';
import {getShops} from "../../api/b2cbusiness/b2c_shopmanage";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
import CustomerServiceComponent from "../../components/CustomerServiceComponent";
export default {
  name: "BusinessOrderTasklist",
  mixins:[MixinCUD],
  components: {
    CustomerServiceComponent,
    TaskOrderComponent
  },
  data(){
    return {
      tableData:[
        {
          avatar:{
            img:"https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
            size:"small",
            shopName: "q点数码旗舰店",
            dateTime: "2021/6/15 19:35:06 ",
            typeName: "手机淘宝无截图版"
          },
          orderNum:3,
          taskNum:"890288",
          status: "进行中",
          image:"https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
          productTitle:"华为小米手机适用智能儿童电话手表防水时尚户外全网通小学生天才男女孩定位可插卡4G正品多功能超长待机",
        }

      ],
      tabsActive: "first",
      tabsActives: {
        "first": {
          lable:"全部",
          value:"first"
        },
        "second": {
          lable: "待放出",
          value: "second"
        },
        "third": {
          lable: "准备中",
          value: "third"
        },
        "fourth": {
          lable: "已下单",
          value:"fourth"
        },
        "five": {
          lable: "复活",
          value: "five"
        },
        "six": {
          lable: "超时发货",
          value: "six"
        },
        "seven": {
          lable: "申诉审核中",
          value: "seven"
        },
        "eight": {
          lable: "申诉完成",
          value: "eight"
        },
        "nine": {
          lable: "退款审核中",
          value: "nine"
        },
        "ten": {
          lable: "已退款",
          value: "ten"
        },
        "elevn": {
          lable: "已完成",
          value: "elevn"
        }
      },
      allShops: [],
      allTaskTypes:[],
      options:[
        {
          reviewStatus:"已追评",
        },
        {
          reviewStatus:"未追评",
        }
      ],
      queryFormRefName:"queryForm",
      queryForm:{
        shopInfo: null,
        tasktype: null,
        taskId: '',
        plateordernum: '',
        orderNum: '',
        customerId: null,
        plateformUsername: '',
        reviewstatus: '',
        timeRange: []
      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    getShops({shopNum:null,
      shopName:null,
      shopUsername:null,
      shopType: null,
      shopMajorTypeId:null,
      status:null,
      shopGroup:null}).then(res=>{
      if (res.success){
        console.log(res.data)
        this.allShops = res.data;
      }
    });

    getAllTaskType().then(res => {
      console.log(res.data)
      this.allTaskTypes = res.data;
    });
  },
  methods: {
    exportUserOrderInfo(){
      this.queryForm.status = this.tabsActives[this.tabsActive].lable;
      this.queryForm.roleCode = "business"
      this.$refs.taskOrderCom.exportUserOrderInfo(this.queryForm);
    },
    tableChange(tab, evnt){
      console.log(this.tabsActives[this.tabsActive])
      this.$refs.taskOrderCom.changeTabs(this.tabsActives[this.tabsActive]);
    },
    getData(){
      this.$refs.taskOrderCom.getData();
    },
    changePageInfo(pagination){
      console.log(pagination)
      this.pagination = pagination;
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      //this.submitQueryForm()
      this.$refs.taskOrderCom.handlePageSizeChange(val);
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      //this.submitQueryForm()
      this.$refs.taskOrderCom.handlePageNumChange(val);
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
.el-tabs-self{
  position: relative;
  width: 100%;
  margin-top: 10px;
}
</style>
